var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgVault = function SvgVault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    d: "M2.582.933h21.236l-1.316 2.292H6.575l5.936 10.283-1.339 2.323L2.582.933ZM.438 4.315h2.69l8.03 13.92L17.14 7.87h2.682l-8.665 15.011L.437 4.316Zm8.25.087L9.963 6.69h11.934L11.854 24.091l1.34 2.332 12.71-22.021H8.687Z",
    clipRule: "evenodd"
  })));
};
var Memo = /*#__PURE__*/memo(SvgVault);
export default Memo;